module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-regular-0c94e034ca06357576c2d03d623e1fcd.woff2";